import { RSAA } from 'redux-api-middleware';
import api from '../../api';
import axios from 'axios';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/singleProduct/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/singleProduct/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/singleProduct/LOAD_FAILURE';

const LOAD_PRICE_SUCCESS = 'farmakom/singleProduct/price/LOAD_SUCCESS';
const LOAD_SIMILARS_SUCCESS = 'farmakom/singleProduct/similars/LOAD_SUCCESS';
const LOAD_BOUGHT_TOGETHER_SUCCESS =
  'farmakom/singleProduct/boughtTogether/LOAD_SUCCESS';
const LOAD_FREE_PRODUCTS_SUCCESS =
  'farmakom/singleProduct/freeProducts/LOAD_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadProductBySeoName(params) {
  return async function(dispatch, getState) {
    dispatch({ type: LOAD_REQUEST });

    let { endpoint, method, headers } = api.getProductBySeoName(params.product);
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    try {
      const response = await axios({
        url: endpoint,
        method,
        headers: headersWithStoreId,
      });

      if (response.status === 200) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: LOAD_FAILURE,
        });
      }
    } catch (error) {
      console.error('Errore durante il caricamento del prodotto', error);
      dispatch({
        type: LOAD_FAILURE,
        message: error.message || 'Something went wrong.',
      });
    }
  };
}

export function loadProductByName(params) {
  return {
    [RSAA]: {
      ...api.getProductBySeoName(params),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

export function loadPrice() {
  return async function(dispatch, getState) {
    try {
      const storeid = getState().store.data.storeId;
      if (!storeid) return;

      const product = getState().singleProduct.data;
      if (!product || !product.seoName) return;

      const { endpoint, method, headers } = api.getProductPriceBySeoName(
        product.seoName
      );

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      const response = await axios({
        url: endpoint,
        method,
        headers: headersWithStoreId,
      });

      if (response.status === 200) {
        if (product.price !== response.data.price) {
          dispatch({
            type: LOAD_PRICE_SUCCESS,
            payload: response.data,
          });
        }
      }
    } catch (error) {
      console.error(
        'Errore durante il caricamento del prezzo del prodotto senza cache',
        error
      );
    }
  };
}

export function loadSimilar() {
  return async function(dispatch, getState) {
    try {
      const storeid = getState().store.data.storeId;
      if (!storeid) return;

      const product = getState().singleProduct.data;
      if (!product || !product.seoName) return;

      const { endpoint, method, headers } = api.getSimilarProductsBySeoName(
        product.seoName
      );

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      const response = await axios({
        url: endpoint,
        method,
        headers: headersWithStoreId,
      });

      if (response.status === 200) {
        dispatch({
          type: LOAD_SIMILARS_SUCCESS,
          payload: response.data.items,
        });
      }
    } catch (error) {
      console.error('Errore durante il caricamento dei prodotti simili', error);
    }
  };
}

export function loadBoughtTogether() {
  return async function(dispatch, getState) {
    try {
      const storeid = getState().store.data.storeId;
      if (!storeid) return;

      const product = getState().singleProduct.data;
      if (!product || !product.seoName) return;

      const {
        endpoint,
        method,
        headers,
      } = api.getBoughtTogetherProductsBySeoName(product.seoName);

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      const response = await axios({
        url: endpoint,
        method,
        headers: headersWithStoreId,
      });

      if (response.status === 200) {
        dispatch({
          type: LOAD_BOUGHT_TOGETHER_SUCCESS,
          payload: response.data.items,
        });
      }
    } catch (error) {
      console.error(
        'Errore durante il caricamento dei prodotti spesso comprati insieme',
        error
      );
    }
  };
}

export function loadFreeProducts() {
  return async function(dispatch, getState) {
    try {
      const storeid = getState().store.data.storeId;
      if (!storeid) return;

      const product = getState().singleProduct.data;
      if (!product || !product.seoName) return;

      const { endpoint, method, headers } = api.getFreeProductsById(product.id);

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      const response = await axios({
        url: endpoint,
        method,
        headers: headersWithStoreId,
      });

      if (response.status === 200) {
        dispatch({
          type: LOAD_FREE_PRODUCTS_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.error(
        'Errore durante il caricamento dei prodotti spesso comprati insieme',
        error
      );
    }
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  loadingPrice: false,
  error: '',
  data: {
    similar: [],
    boughtTogether: [],
    freeProducts: [],
  },
};

export default function singleProductReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case LOAD_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...action.payload },
        error: null,
      };
    case LOAD_SIMILARS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, similar: action.payload },
        error: null,
      };
    case LOAD_BOUGHT_TOGETHER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, boughtTogether: action.payload },
        error: null,
      };
    case LOAD_FREE_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, freeProducts: action.payload },
        error: null,
      };
    default:
      return state;
  }
}
